
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import 'bootstrap-daterangepicker/daterangepicker.css'; // Import Date Range Picker CSS
import 'bootstrap-daterangepicker'; // Import Date Range Picker JS
import moment from 'moment'
function CreateCustomeUi({ formik, date, datepickerRef }) {
  // useEffect(() => {
  //   // Initialize the Date Range Picker
  //   $('#reservation').daterangepicker({
  //     startDate: moment().startOf('day'),
  //     endDate: moment().endOf('day'),
  //     // Additional options can be added here
  //   }, function(start, end) {
  //     // Update formik state with the selected date range
  //     formik.setFieldValue('dateRange', `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`);
  //   });
  // }, [formik]);
  return (
    <div className="content-wrapper" style={{ minHeight: "calc(100vh - 56.5px)" }}>
      {/* Content Header */}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Create Customer</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Create</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 m-auto">
              <div className="card card-primary">
                <form onSubmit={formik.handleSubmit}>
                  <div className="card-body">
                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        name="name"
                        className={`form-control ${formik.errors.name && formik.touched.name ? "is-invalid" : ""}`}
                        id="name"
                        placeholder="Enter Name"
                        {...formik.getFieldProps("name")}
                      />
                      {formik.errors.name && formik.touched.name && (
                        <span className="invalid-feedback">{formik.errors.name}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="select">Select:</label>
                      <div>
                        <select
                          id="select"
                          className={`w-100 p-2 ${formik.errors.select && formik.touched.select ? "is-invalid" : ""}`}
                          {...formik.getFieldProps("select")}
                        >
                          <option value="">Select...</option>
                          <option value="option1">Option 1</option>
                          <option value="option2">Option 2</option>
                          <option value="option3">Option 3</option>
                        </select>
                        {formik.errors.select && formik.touched.select && (
                          <span className="invalid-feedback">{formik.errors.select}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Date range:</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="far fa-calendar-alt" />
                          </span>
                        </div>
                        <input
                          type="text"
                          className="form-control float-right"
                          id="reservation"
                          name="dateRange" // Update the name to match Formik's state
                          value={formik.values.dateRange} // Bind the value to Formik
                          onChange={formik.handleChange} // Handle change with Formik
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="datepicker">Select Date</label>
                      <input
                        type="text"
                        className="form-control"
                        id="datepicker"
                        placeholder="Select Date"
                        ref={datepickerRef}
                        value={date}
                        onChange={() => {}}
                      />
                      {formik.errors.date && formik.touched.date && (
                        <span className="invalid-feedback">{formik.errors.date}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email address</label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control ${formik.errors.email && formik.touched.email ? "is-invalid" : ""}`}
                        id="email"
                        placeholder="Enter email"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.errors.email && formik.touched.email && (
                        <span className="invalid-feedback">{formik.errors.email}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        name="password"
                        className={`form-control ${formik.errors.password && formik.touched.password ? "is-invalid" : ""}`}
                        id="password"
                        placeholder="Password"
                        {...formik.getFieldProps("password")}
                      />
                      {formik.errors.password && formik.touched.password && (
                        <span className="invalid-feedback">{formik.errors.password}</span>
                      )}
                    </div>

                    <div className="form-group mb-0">
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          name="terms"
                          className={`custom-control-input ${formik.errors.terms && formik.touched.terms ? "is-invalid" : ""}`}
                          id="terms"
                          {...formik.getFieldProps("terms")}
                        />
                        <label className="custom-control-label" htmlFor="terms">
                          I agree to the <a href="#">terms of service</a>.
                        </label>
                      </div>
                      {formik.errors.terms && formik.touched.terms && (
                        <span className="invalid-feedback">{formik.errors.terms}</span>
                      )}
                    </div>
                  </div>

                  <div className="card-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CreateCustomeUi;
